import { createRouter, createWebHistory } from "vue-router";
import { afterEachGuard, beforeEachGuard } from "@/guards";

const routes = [
  // ============================
  // ADMIN PANEL + NESTED ROUTES
  // ============================
  {
    path: "/admin",
    name: "Admin",
    component: () => import("@/views/AdminPanel.vue"),
    meta: {
      requiresAuth: true,
      requiresAdmin: true,
      shouldAppearInMenu: true,
      title: "سی آر ام - مدیریت",
      menuName: "مدیریت",
      icon: "wpf:administrator",
    },
    children: [
      {
        path: "",
        redirect: { name: "LeadTransfer" },
      },
      {
        path: "lead-transfer",
        name: "LeadTransfer",
        component: () => import("@/views/LeadTransfer.vue"),
        meta: {
          title: "مدیریت - انتقال لید",
          menuName: "انتقال لید",
          icon: "mingcute:transfer-line",
        },
      },
      {
        path: "lead-distribution",
        name: "LeadDistribution",
        component: () => import("@/views/LeadDistribution.vue"),
        meta: {
          title: "مدیریت - پخش لید",
          menuName: "پخش لید",
          icon: "fluent-mdl2:distribute-down",
        },
      },
      {
        path: "user-control",
        name: "UserControl",
        component: () => import("@/views/UserControl.vue"),
        meta: {
          title: "مدیریت - مدیریت کاربران",
          menuName: "مدیریت کاربران",
          icon: "ix:user-management-settings",
        },
      },
    ],
  },

  // ============================
  // CONTACTS
  // ============================
  {
    path: "/contacts",
    name: "contacts",
    component: () => import("@/views/ContactsPage.vue"),
    meta: {
      requiresAuth: true,
      title: "سی آر ام - مخاطبین",
      menuName: "مخاطبین",
      icon: "solar:phone-linear",
      shouldAppearInMenu: true,
    },
  },

  // ============================
  // PROFILE
  // ============================
  {
    path: "/profile",
    name: "profile",
    component: () => import("@/views/ChangeProfile.vue"),
    meta: {
      requiresAuth: true,
      shouldAppearInMenu: false,
      title: "سی آر ام - اطلاعات حساب",
    },
  },

  // ============================
  // LEADS
  // ============================
  {
    path: "/leads",
    name: "leads",
    component: () => import("@/views/LeadsPage.vue"),
    meta: {
      requiresAuth: true,
      title: "سی آر ام - لیدها",
      menuName: "لید ها",
      icon: "ph:list-fill",
      shouldAppearInMenu: true,
    },
  },

  // ============================
  // REMINDERS
  // ============================
  {
    path: "/reminders",
    name: "reminders",
    component: () => import("@/views/RemindersPage.vue"),
    meta: {
      requiresAuth: true,
      title: "سی آر ام - یادآورها",
      menuName: "یادآوری",
      icon: "lucide:list-todo",
      shouldAppearInMenu: true,
    },
  },

  {
    path: "/remindersV2",
    name: "remindersV2",
    component: () => import("@/views/RemindersPageV2.vue"),
    meta: {
      requiresAuth: true,
      title: "سی آر ام - یادآورها",
      icon: "lucide:list-todo",
      shouldAppearInMenu: true,
    },
  },

  // ============================
  // CONTACT VIEW (Dynamic)
  // ============================
  {
    path: "/contacts/:contactId",
    name: "ContactView",
    component: () => import("@/views/ContactView.vue"),
    meta: {
      requiresAuth: true,
      title: "سی آر ام - جزئیات مخاطب",
      shouldAppearInMenu: false,
    },
  },

  // ============================
  // LEAD VIEW (Dynamic)
  // ============================
  {
    path: "/leads/:leadId",
    name: "LeadView",
    component: () => import("@/views/LeadView.vue"),
    meta: {
      requiresAuth: true,
      title: "سی آر ام - جزئیات لید",
      shouldAppearInMenu: false,
    },
  },

  // ============================
  // VERSION
  // ============================
  {
    path: "/version",
    name: "version",
    component: () => import("@/views/VersionPage.vue"),
    meta: {
      title: "سی آر ام - نسخه",
      shouldAppearInMenu: false,
    },
  },

  // ============================
  // LOGIN PAGE
  // ============================
  {
    path: "/login",
    name: "login",
    component: () => import("@/views/LoginPage.vue"),
    meta: { title: "سی آر ام - ورود", shouldAppearInMenu: false },
  },

  // ============================
  // LOGOUT PAGE
  // ============================
  {
    path: "/logout",
    name: "logout",
    meta: {
      menuName: "خروج",
      icon: "material-symbols:logout",
      shouldAppearInMenu: false,
    },
    component: () => import("@/views/LogoutPage.vue"),
  },

  // ============================
  // SMS LOGS
  // ============================

  {
    path: "/sms-logs",
    name: "smsLogs",
    component: () => import("@/views/SmsLogs.vue"),
    meta: {
      requiresAuth: true,
      title: "سی آر ام - گزارش پیامک ها",
      menuName: "گزارش پیامک ها",
      icon: "streamline-plump:file-report",
      shouldAppearInMenu: true,
    },
  },

  // ============================
  // MESSAGES
  // ============================
  {
    path: "/messages",
    name: "messages",
    component: () => import("@/views/MessagesView.vue"),
    meta: {
      requiresAuth: true,
      title: "سی آر ام - پیام‌ها",
      menuName: "پیام ها",
      icon: "tabler:messages",
      shouldAppearInMenu: true,
    },
    children: [
      {
        path: "",
        redirect: { name: "TextMessages" },
      },
      {
        path: "text",
        name: "TextMessages",
        component: () => import("@/views/TextMessages.vue"),
        meta: {
          title: "پیام ها - پیامک",
          menuName: "پیامک",
          icon: "mdi:message-text-fast-outline",
        },
      },
      {
        path: "whatsapp",
        name: "WhatsAppMessages",
        component: () => import("@/views/WhatsAppMessages.vue"),
        meta: {
          title: "پیام ها - واتس اپ",
          menuName: "واتس اپ",
          icon: "ic:baseline-whatsapp",
        },
      },
    ],
  },

  // ============================
  // CATCH-ALL REDIRECT
  // ============================
  {
    path: "/:pathMatch(.*)*",
    redirect: "/leads",
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

// Guards
router.beforeEach(beforeEachGuard);
router.afterEach(afterEachGuard);

export default router;
